class Office365Service {
  constructor() {
    this.isInitialized = false;
  }

  // Check if Office 365 SSO is available
  isSSoAvailable() {
  try {
    // Check if we're in Office.js environment
    if (typeof Office === 'undefined' || !Office.context) {
      return false;
    }

    // Check if we have MODERN auth capabilities (Office.auth, not Office.context.auth)
    const hasAuthCapabilities = !!(
      Office.auth &&
      typeof Office.auth.getAccessToken === 'function'
    );
    
    if (!hasAuthCapabilities) {
      return false;
    }

    return hasAuthCapabilities;
  } catch (error) {
    return false;
  }
}

  // Get Office 365 access token using SSO
  async getOffice365Token() {
  if (!this.isSSoAvailable()) {
    throw new Error('Office 365 SSO not available on this platform');
  }

  try {
    
    // Use modern API (Promise-based, not callback-based)
    const accessToken = await Office.auth.getAccessToken({
      allowConsentPrompt: true,
      allowSignInPrompt: true,
      //forMSGraphAccess: true
    });
try {
      const tokenParts = accessToken.split('.');
      const payload = JSON.parse(atob(tokenParts[1]));
    } catch (e) {
    }
    return accessToken;

  } catch (error) {
    let errorMessage = 'Office 365 authentication failed';
    
    switch (error.code) {
      case 13001:
        errorMessage = 'User not signed in to Office 365';
        break;
      case 13002:
        errorMessage = 'User consent required';
        break;
      // ... keep your existing error cases
      case 13012:
        errorMessage = 'API is not supported in this platform';
        break;
      default:
        errorMessage = `${error.message} (Code: ${error.code})`;
    }
    
    throw new Error(errorMessage);
  }
}

  // Get user profile from Microsoft Graph
  async getUserProfile(accessToken) {
    try {
      
      const response = await fetch('https://graph.microsoft.com/v1.0/me', {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Graph API error: ${response.status} ${response.statusText}`);
      }

      const profile = await response.json();
      
      return {
        success: true,
        data: profile
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Get Office 365 user info for login (main method)
  async getOffice365UserInfo() {
    try {
      
      // Get access token using SSO
      const accessToken = await this.getOffice365Token();
      
      // Get user profile from Microsoft Graph
      const profileResult = await this.getBasicUserInfo(accessToken);
		if (!profileResult) {
			throw new Error('No user information available from Office context');
		}

      return {
        success: true,
        data: {
          accessToken: accessToken,
          profile: {
            email: profileResult.email,
            displayName: profileResult.displayName,
            timeZone: profileResult.timeZone,
          }
        }
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Check if user is signed into Office 365
  isUserSignedIn() {
    return !!(
      typeof Office !== 'undefined' &&
      Office.context &&
      Office.context.mailbox &&
      Office.context.mailbox.userProfile
    );
  }

  // Get basic user info from Office context
  getBasicUserInfo() {
    if (!this.isUserSignedIn()) {
      return null;
    }

    try {
      const userProfile = Office.context.mailbox.userProfile;
      return {
        email: userProfile.emailAddress,
        displayName: userProfile.displayName,
        timeZone: userProfile.timeZone
      };
    } catch (error) {
      return null;
    }
  }
}

export default new Office365Service();